import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, propTypes, reduxForm } from 'redux-form';
import { load as loadLaborClassesAction } from '../../../../reducers/laborClasses/laborClasses.actions';
import { laborClasses as getLaborClasses } from '../../../../reducers/laborClasses/laborClasses.reducer';
import { load as loadSubContractorsAction } from '../../../../reducers/subContractor/subContractor.actions';
import { subContractors as getSubContractors } from '../../../../reducers/subContractor/subContractor.reducer';
import {
  remove as removeAction,
  save as saveAction,
} from '../../../../reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.actions';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import './SubContractorTimesheetForm.css';

// eslint-disable-next-line object-curly-newline
export class SubContractorTimesheetForm extends React.Component {
  componentDidMount() {
    this.props.loadSubContractors();
    this.props.loadLaborClasses();
  }

  render() {
    const {
      subContractors,
      laborClasses,
      remove,
      subContractor: { id, removing },
      handleSubmit,
      save,
      disabled,
      currentSubcontractorId,
    } = this.props;
    const currentSubcontractor = subContractors.filter(a => a.id === parseInt(currentSubcontractorId, 10))[0];
    const isOther = currentSubcontractor && currentSubcontractor.name === 'Other';

    return (
      <Form
        onSubmit={() => {
        }}
        onChange={() => setTimeout(handleSubmit(params => save(params)))}
      >
        <Row>
          <Col sm={4} >
            <Field
              component={SelectFormGroup}
              name="subcontractor_id"
              label="Sub-Contractor"
              options={subContractors}
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={SelectFormGroup}
              name="labor_class_id"
              label="Class"
              options={laborClasses}
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={2} >
            <Field
              component={TTFormGroup}
              name="hours"
              label="Hours"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
          { !isOther &&
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
          }
        </Row>
        { isOther &&
        <Row>
          <Col sm={11} >
            <Field
              component={TTFormGroup}
              name="other_name"
              label="Other Name"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
        </Row>
        }
      </Form>);
  }
}

SubContractorTimesheetForm.propTypes = {
  ...propTypes,
  subContractors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  laborClasses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remove: PropTypes.func.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.subContractor,
  form: `subContractor${ownProps.subContractor.id}`,
  subContractors: getSubContractors(state),
  laborClasses: getLaborClasses(state),
  currentSubcontractorId: formValueSelector(`subContractor${ownProps.subContractor.id}`)(state, 'subcontractor_id'),
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  loadSubContractors: () => dispatch(loadSubContractorsAction()),
  loadLaborClasses: () => dispatch(loadLaborClassesAction()),
  save: values => dispatch(saveAction(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  enableReinitialize: true,
})(SubContractorTimesheetForm));



// WEBPACK FOOTER //
// ./src/components/WorkOrder/SubContractorTimesheets/SubContractorTimesheetForm/SubContractorTimesheetForm.jsx